import set from 'lodash/set';


function initialState() {
  return {
    name: '',
    email: '',
    rfc: '',
    companyName: '',
    tradeName: '',
    multiUser: '',
    accountNumber: '',
    projectName: '',
    oldRfc: '',
    count: 0,
    totalCount: 0,
    totalPages: 0,
    page: 1,
    size: 20,
    csv: null,
    csvFileName: '',
    list: [],
    phoneNumber: '',
  };
}

export default {
  setValue(state, { accessor, value }) {
    set(state, accessor, value);
  },
  setCompanyValue(state, { accessor, value }) {
    set(state.company, accessor, value);
  },
  setValues(state, payload) {
    Object.keys(payload).forEach((key) => {
      set(state, key, payload[key]);
    });
  },
  cleanSensitiveData(state) {
    set(state, 'password', '');
    set(state, 'passwordConfirmation', '');
  },
  setInitialState(state) {
    const newState = initialState();
    Object.keys(newState).forEach((key) => {
      set(state, key, newState);
    });
  },
};
